import View from "ln/view/View";
import Node from "ln/node/Node";
import Template from "ln/template/TemplateManager";
import VideoPlayer from '../VideoPlayer';
import { toMSString } from './helpers';
import List from "ln/list/List";
import ListRenderer from "ln/list/ListRenderer";


export interface MarkerInterface{
    time:number;
    text:string;
}

class ProgressBar extends View{

    private markers:MarkerInterface[];
    private markerList:ListRenderer<MarkerInterface>;
    private current:string = '0:00';

    constructor( public player:VideoPlayer ){
        super();

        this.defaultTemplate = 'lv.video-progress';

        this.player.time.add( this.update, this );
        this.player.time.add( this.updateBuffer, this );
        this.player.duration.add( this.renderMarkers, this );
        
    }

    public init(){
        
        this.markerList = new ListRenderer<MarkerInterface>( this.node.js( 'markers' ) );

        this.markerList.defaultRender( ( marker:MarkerInterface ) => {
            let markerObj = {
                percent: this.toPercentage( marker.time ),
                text: marker.text
            };

            let markerNode = Node.fromHTML( Template.render( 'lv.progress-chapter-marker', markerObj ) );
            markerNode.click.add( () => {
                this.player.moveToTime( marker.time );
                this.player.play();
            });

            return  { node: markerNode };
        });
        
        this.node.js( 'clickhandler' ).click.add( this.onClicked, this );
        this.node.js( 'clickhandler' ).mousemove.add( this.displayTime, this );
    }

    protected renderData(){
        return { current: this.current };
    }

    private update( currentTime:number ){
        this.node.js( 'progress' ).style.width = this.toPercentage( currentTime ) + '%';
    }

    private updateBuffer( currentTime:number ){
        let timeRange = this.player.video.buffered;
        if( timeRange.length > 0 ) this.node.js( 'buffer' ).style.width = ( timeRange.end(0) / this.player.video.duration * 100 ) + '%';
    }

    public addMarker( marker:MarkerInterface ){
        this.markers.push( marker );
        ( this.markerList.source as List<MarkerInterface> ).append( marker );
    }

    public setMarkers( markers:MarkerInterface[] ){
        this.markers = markers;
        this.renderMarkers();
    }

    private renderMarkers(){
        this.markerList.source = new List<MarkerInterface>( this.markers );
    }

    private onClicked( n:Node, e:MouseEvent ){
        this.player.moveToPercentage( e.offsetX / n.bounds().width * 100 );
    }

    private displayTime( n:Node, e:MouseEvent ){
        var percentage = ( e.offsetX / n.bounds().width * 100 );
        this.current = toMSString( percentage * this.player.video.duration / 100 );
        this.node.js( 'time' ).html = this.current;
        this.node.js( 'time' ).style.left = percentage + '%';
    }

    private toPercentage( time:number ){
        return ( time == 0 ) ? time : time / this.player.video.duration * 100;
    }

}

export default ProgressBar;